import { CONNECTION_APP_SECTIONS } from './connectionAppsCatalogSections.js'

export function getAllConnectionApps() {
  const seenSlugs = new Set()
  const out = []
  for (const section of CONNECTION_APP_SECTIONS) {
    for (const app of section.apps) {
      const key = String(app.slug || '').toLowerCase()
      if (seenSlugs.has(key)) continue
      seenSlugs.add(key)
      out.push({ ...app, sectionId: section.id, sectionTitle: section.title })
    }
  }
  return out
}
